import type { ComponentProps } from "react";
import { Input as Base } from "./InputBase";
import "./controls.web.css";

/** The shared text field with the desktop web styling. */
export function Input({ className, ...props }: ComponentProps<typeof Base>) {
  return <Base {...props} className={`desktop-input ${className ?? ""}`} />;
}
